<template>
    <b-card>
        <div slot="header">
        <i class="fa fa-line-chart" aria-hidden="true"></i>
            Average Spending Per Ticket : ยอดค่าใช้จ่ายโดยเฉลี่ยต่อ 1 ใบเสร็จ
        </div>
         <b-row>
            <!-- Date range -->
            <b-col sm="12" md="6">
                <b-row>
                    <b-col sm="12" md="2">
                        <label class="label-filter">Time</label>
                    </b-col>
                    <b-col sm="12" md="10">
                        <v-date-picker
                            class="date-picker"
                            mode='range'
                            locale="th-TH"
                            color="gray"
                            :columns="$screens({ default: 1, lg: 2 })"
                            :popover="{ visibility: 'focus' }"
                            :input-props="{ placeholder: 'enter start-end time', readonly: true }"
                            v-model='time'
                            >
                        </v-date-picker>
                    </b-col>
                </b-row>
            </b-col>
            <!-- category -->
            <b-col sm="12" md="6">
                <b-row>
                    <b-col sm="12" md="2">
                        <label class="label-filter">category</label>
                    </b-col>
                    <b-col sm="12" md="10">
                        <v-select
                            @input="getData"
                            class="v-select"
                            v-model="form.categories"
                            :options="categoryList"
                            multiple
                            :placeholder="'enter category'">
                        </v-select>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <!-- Shop -->
            <b-col sm="12" md="6">
                <b-row>
                    <b-col sm="12" md="2">
                        <label class="label-filter">Shop</label>
                    </b-col>
                    <b-col sm="12" md="10">
                        <v-select
                            @input="getData"
                            class="v-select"
                            v-model="form.shops"
                            :options="shopList"
                            multiple
                            :placeholder="'enter shop'">
                        </v-select>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <div class="div-hr">
          <span class="span-hr" v-if="isLoading">
            <b-spinner small type="grow"></b-spinner>Loading
          </span>
          <span class="span-hr" v-if="errorMessage != ''">
            <font class="error-message">{{ errorMessage }} </font>
          </span>
        </div>
        <line-chart class="chart" :chart-data="datacollection" :options="chartOptions"></line-chart>
        <b-button variant="ghost-primary" @click="showDetails = !showDetails">See details</b-button>
        <b-button variant="ghost-dark" @click="exportFile">
          <i class="fa fa-download" aria-hidden="true"></i>Download
        </b-button>
        <transition name="custom-classes-transition"
                enter-active-class="animated fadeInDown"
                leave-active-class="animated fadeOut">
        <b-row class="mx-2 my-1" v-if="showDetails">
            <b-table
            table-class="table-datasets"
            :items="tableItems"
            :fields="tableFields"
            responsive
            small
            ></b-table>
        </b-row>
        </transition>
    </b-card>
</template>

<script>
import LineChart from '../../components/chart/LineChart';
import vSelect from 'vue-select';
import { getDateBefore, dateToString, dateToYYYYMMDD } from '../../assets/utils/time';
import { OptionList } from '../../models/option-list';

export default {
  components: {
    LineChart,
    'v-select': vSelect
  },
  data () {
    return {
      isLoading: false,
      errorMessage: '',
      datacollection: null,
      chartOptions: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Time (days)'
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Average Spending Per Ticket ( Point )'
            }
          }]
        }
      },
      shopList: [],
      categoryList: [],
      time: {
        start: getDateBefore(30),
        end: new Date()
      },
      form: {
        shops: [],
        categories: []
      },
      showDetails: false,
      chartData: {
        dateList: [],
        datasets: []
      }
    };
  },
  mounted () {
    // initial data
    let pointer = new Date(this.time.start);
    let dateList = [];
    while (true) {
      dateList.push(dateToString(pointer));
      pointer.setDate(pointer.getDate() + 1);
      if (pointer.getTime() > this.time.end.getTime()) {
        break;
      }
    }
    this.chartData.dateList = dateList;
    const optionList = new OptionList(this.axios);
    optionList.loadShops()
      .then(response => {
        this.shopList = response;
      })
      .catch(error => {
        this.handleError(error);
      });
    optionList.loadCategories()
      .then(response => {
        this.categoryList = response;
      })
      .catch(error => {
        this.handleError(error);
      });
    this.getData();
  },
  computed: {
    tableFields () {
      const header = this.chartData.dateList.map(value => {
        return { key: value };
      });
      return [{ key: 'name' }, ...header];
    },
    tableItems () {
      const fields = this.tableFields;
      const datasets = this.chartData.datasets;
      const tableItems = [];
      for (const set of datasets) {
        let tableRow = {};
        tableRow['name'] = set.name;
        for (let i = 1; i < fields.length; i++) {
          tableRow[fields[i].key] = set.data[i - 1];
        }
        tableItems.push(tableRow);
      }
      return tableItems;
    },
    hueList () {
      let hue = [];
      for (let i = 0; i < 2; i++) {
        for (let j = 0; j < 6; j++) {
          hue.push((360 * ((j) * 60) / 360) + (i * 30));
        }
      }
      return hue;
    }
  },
  methods: {
    fillData () {
      let index = 0;
      const datasets = this.chartData.datasets.map(data => {
        let hue = this.hueList[index++];
        return {
          backgroundColor: `hsl(${hue}, 100%, 85%)`,
          borderColor: `hsl(${hue}, 50%, 65%)`,
          borderWidth: 1,
          label: data.name,
          data: data.data,
          fill: false
        };
      });
      this.datacollection = {
        labels: this.chartData.dateList,
        datasets: datasets
      };
    },
    getData () {
      // set data
      const dateSelect = {
        start: dateToString(this.time.start),
        end: dateToString(this.time.end)
      };
      const dataSelect = [...this.form.categories, ...this.form.shops];
      const dataChartCode = this.chartData.datasets.map(data => data.code);

      if (0 === dataSelect.length) {
        this.chartData.datasets = [];
        this.addAverageSpendingPerTicket('all');
      } else if (dateSelect.start !== this.chartData.dateList[0] ||
          dateSelect.end !== this.chartData.dateList[this.chartData.dateList.length - 1]) {
        // in case time range change will refresh all
        this.chartData.datasets = [];
        dataSelect.forEach(data => {
          this.addAverageSpendingPerTicket(data.code);
        });
      } else {
        // update some dataset
        const missingList = [];
        const overList = [];

        dataSelect.forEach(data => { // find missing data from chart
          let isExist = false;
          for (let code of dataChartCode) {
            if (data.code === code) {
              isExist = true;
            }
          }
          if (!isExist) {
            missingList.push(data.code);
          }
        });

        dataChartCode.forEach(code => { // find over data from chart
          let isExist = false;
          for (let data of dataSelect) {
            if (code === data.code) {
              isExist = true;
            }
          }
          if (!isExist) {
            overList.push(code);
          }
        });

        if (missingList.length > 0) { // get data from MQDC API
          missingList.forEach(code => {
            this.addAverageSpendingPerTicket(code);
          });
        }
        if (overList.length > 0) { // remove data from chartData
          overList.forEach(code => {
            const removeIndex = this.chartData.datasets.findIndex(data => data.code === code);
            this.chartData.datasets.splice(removeIndex, 1);
          });
          this.fillData();
        }
      }
    },
    addAverageSpendingPerTicket (code) {
      const startDate = dateToYYYYMMDD(this.time.start);
      const endDate = dateToYYYYMMDD(this.time.end);
      let url = process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/reports/average-spending-per-receipt' +
          `?startDate=${startDate}&endDate=${endDate}`;
      if ('all' !== code) {
        if (this.shopList.find(shop => shop.code === code)) {
          url = url + `&shopIds=${code}`;
        } else if (this.categoryList.findIndex(category => category.code === code)) {
          url = url + `&categoryIds=${code}`;
        }
      }
      this.isLoading = true;
      this.errorMessage = '';
      this.axios.get(url)
        .then(response => {
          const data = response.data.data;
          this.chartData.dateList = data.map(d => {
            const split = d.date.split('-');
            return `${split[2]}/${split[1]}`;
          });
          const dataset = {
            name: this.getNameByCode(code), code: code, data: data.map(d => d.average)
          };
          this.chartData.datasets.push(dataset);
          this.isLoading = false;
          this.fillData();
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    getNameByCode (code) {
      const result = [...this.categoryList, ...this.shopList].find(list => list.code === code);
      return 'all' === code ? 'all' : (result.label || '');
    },
    handleError (error) {
      this.errorMessage = 'Error : ' + error.response.data.message || error.message;
      this.isLoading = false;
    },
    exportFile () {
      console.log('implement here and this data', JSON.stringify(this.chartData));
    }
  },
  watch: {
    time () {
      this.getData();
    }
  }
};
</script>

<style scoped>
  .chart {
    max-height: 300px;
  }
  .label-filter {
    color: #5c6873;
    margin-bottom: 0px;
    padding-top: 5px;
    margin-left: 5px;
  }
  .div-hr{
    width:100%;
    height: 13px;
    border-bottom: 1px solid #bfc3c7;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .span-hr{
    font-size: 13px;
    padding: 0 10px;
    background-color: #ffffff;
    color: #5c6873;
  }
  .error-message{
    color: #f86c6b;
  }

</style>

<style>
  .table-datasets{
    color: #5c6873;
    text-align: center;
    font-size: 12px;
  }
  .v-select .vs__search::placeholder,
  .v-select .vs__dropdown-toggle,
  .v-select .vs__dropdown-menu {
    text-transform: lowercase;
    color: #394066;
    border: 1px solid #e4e7ea;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .vs__actions{
    display: none;
  }
  .v-select .vs__selected {
    background-color: rgb(255, 255, 255);
    color: #5c6873;
  }
</style>
